import { scopeCompletionSource } from '@codemirror/lang-javascript';
// import _ from 'lodash-es';
import { BaseController } from '~/utils/base-controller';
import './kform-script-editor.scss';
import {
	ThemeExtensions, LanguageExtensions, Plugins, Keymaps,
} from '@knitiv/code-editor';

export default class kformScriptEditor extends BaseController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor($injector) {
		super($injector);

		this.ngModel = undefined;

		/** @type {?import('angular').INgModelController} */
		this.ngModelCtrl = null;

		this.rows = 0;
		this.placeholder = '';
		this.onChange = null;
		this.disabled = false;
		this.readonly = false;
	}

	onEditorSetup() {
		// TODO: add completions

		// const components = this.$scope.form ? this.$scope.form.components : undefined;

		// const suggestions = _.map(kformUtils.flattenComponents(components, true), comp => ({
		// 	name: comp.key, value: comp.key, score: 1000, meta: 'component',
		// }));

		// console.log('suggestions', suggestions);

		return [
			ThemeExtensions.oneLight,
			LanguageExtensions.javascript({ typescript: true }),
			LanguageExtensions.javascriptLanguage.data.of({ autocomplete: scopeCompletionSource(globalThis) }),

			Plugins.FOLD_GUTTERS(),
			Plugins.MATCH_BRACKETS(),
			Plugins.AUTOCOMPLETION(),
			Plugins.CLOSE_BRACKETS(),
			Plugins.DRAW_SELECTION(),
			Plugins.DROP_CURSOR(),
			Plugins.HIGHLIGHT_ACTIVE_LINE_GUTTER(),
			Plugins.HIGHLIGHT_SELECTION_MATCHES(),
			Plugins.HIGHLIGHT_SPECIAL_CHARS(),
			Plugins.HISTORY(),
			Plugins.INDENT_ON_INPUT(),
			Plugins.MULTIPLE_CURSORS(),
			Plugins.RECTANGULAR_SELECTION(),
			Plugins.LINE_NUMBERS(),
			Plugins.KEYMAP.of(Keymaps.KNITIV_KEYMAP),
			// onChange,
		];
	}

	$onInit() {
		const rows = this.rows ? this.rows - 0 : 5;

		this.aceStyles = {
			height: `${rows * 25}px`,
		};
	}
}
